import {oxgGenerateUniqueId} from './generate-unique-id.js' 

function oxg_create_tooltip_container() {
    let tooltipContainer = document.createElement('div');
    tooltipContainer.setAttribute('role', 'presentation');
    tooltipContainer.setAttribute('id', 'oxg-tooltip-container');
    tooltipContainer.classList.add('tooltip-container');
    let tooltip = document.createElement("span");
    tooltip.classList.add('tooltip');
    tooltip.setAttribute('id', 'oxg-tooltip');
    tooltipContainer.append(tooltip);
    document.body.append(tooltipContainer);
}

function oxg_destroy_tooltip_container() {
    let tooltipContainer = document.getElementById('oxg-tooltip-container');
    tooltipContainer.remove();
}

const oxg_update_tooltip_position = (e) => {
    let tooltip = document.getElementById('oxg-tooltip');
    let tooltipW = tooltip.offsetWidth;
    let mouseX = e.pageX - window.scrollX + 12;
    let mouseY = e.pageY - window.scrollY + 12;
    let windowW = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    
    tooltip.style.left = (mouseX + tooltipW) < windowW ? mouseX + 'px' : (windowW - tooltipW - 4) + 'px';
    tooltip.style.top = mouseY + 'px';
}

function oxg_tooltips() {
    oxg_create_tooltip_container();
    //get tooltips
    let tooltips = document.querySelectorAll('[data-tooltip]');
    //loop
    tooltips.forEach((tooltipElement) => {
        let text = tooltipElement.dataset.tooltip;
        let id = 'tooltip_' + oxgGenerateUniqueId();
        tooltipElement.addEventListener("mouseenter", function(e) {
            oxg_empty_tooltip();
            oxg_create_tooltip(text);
            tooltipElement.addEventListener("mousemove", function(e) {
                let update = () => { oxg_update_tooltip_position(e) };
                requestAnimationFrame(update);
            });
        });
        tooltipElement.addEventListener("mouseleave", function() {
            oxg_empty_tooltip();
        });
    });
}

function oxg_create_tooltip(text) {
    let tooltip = document.getElementById('oxg-tooltip');
    if ( !tooltip ) return;
    tooltip.innerHTML = "";
    let tooltipContent = document.createElement("p");
    tooltipContent.innerHTML = text;
    tooltip.append(tooltipContent);
    tooltip.style.display = "block";
}

function oxg_empty_tooltip() {
    let tooltip = document.getElementById('oxg-tooltip');
    tooltip.innerHTML = "";
    tooltip.style.display = "none";
}

document.addEventListener('DOMContentLoaded', () => {
    oxg_tooltips();
});